import styled from "styled-components";

export const DeviceMetricsWrapper = styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    grid-gap: 30px;
    grid-template-columns: minmax(0, 1fr);
    grid-auto-rows: minmax(300px, 1fr);
    box-sizing: border-box;
`;

export const ChartWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
`;

export const ChartHeader = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

`;

export const ChartHeaderColorBlock = styled.div`
    width: 3px;
    height: 25px;
    margin-bottom: 5px;
`;

export const ChartName = styled.div`
    font-size: 14px;
`;

export const ChartCurrentValue = styled.div`
    font-size: 24px;
    letter-spacing: 2px;
`;

export const ChartInfo = styled.div`
    display: flex;
    flex-direction: column;
    position: relative
`;

export const ChartLatestMetricTime = styled.div`
    font-size: 11px;
`;

export const ChartUnit = styled.div`
    font-size: 11px;
    margin-top: 3px;
`;

export const EChartsWrapper = styled.div`
    flex: 1 1 auto;
`;

